import React, { ChangeEvent } from 'react';

import { InputGroup } from '@lightspeed/flame/InputGroup';

import { StyledButton, StyledInput } from '../label/HubPrint/InputStepper.style';

export interface NumberInputStepperProps {
  disabled?: boolean;
  value: number;
  onStepperInputChange: (newVal: number) => void;
  limit: [number, number];
}

const NumberInputStepper: React.FC<NumberInputStepperProps> = ({
  disabled = false,
  onStepperInputChange,
  value,
  limit: [minVal, maxVal],
}) => {
  const handleInputChange = React.useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      const { valueAsNumber: newInputValue } = e.target;
      if (isNaN(newInputValue)) {
        onStepperInputChange(value);
      } else {
        const inputNum = Math.max(minVal, Math.min(maxVal, newInputValue));
        onStepperInputChange(inputNum);
      }
    },
    [maxVal, minVal, onStepperInputChange, value]
  );
  return (
    <InputGroup>
      <StyledButton
        data-test="input-stepper-button-decrement"
        onClick={() => onStepperInputChange(value - 1)}
        disabled={disabled || value <= minVal}
      >
        &#8722;
      </StyledButton>
      <StyledInput
        value={value}
        type="number"
        min={minVal}
        data-test="input-number-stepper"
        max={maxVal}
        onFocus={(event) => event.target.select()}
        disabled={disabled}
        onChange={handleInputChange}
      />
      <StyledButton
        data-test="input-stepper-button-increment"
        onClick={() => onStepperInputChange(value + 1)}
        disabled={disabled || value >= maxVal}
      >
        &#43;
      </StyledButton>
    </InputGroup>
  );
};

export default NumberInputStepper;
